import type { Tone } from "@/lib/tone";
import type { Rag } from "./api";

/**
 * The one place a CVCE `rag` colour becomes a portal `Tone` (dev spec I-4):
 * red -> critical, amber -> watch, green -> ok, grey -> neutral. Every tile,
 * card and chart in this module goes through this mapping rather than
 * switching on `rag` itself, so the module never invents a fifth colour.
 */
export function ragTone(rag: Rag | string): Tone {
  if (rag === "red") return "critical";
  if (rag === "amber") return "watch";
  if (rag === "green") return "ok";
  return "neutral";
}
